// This is the code for the modal when it should be controlled via the redux store.
//https://stackoverflow.com/questions/35623656/how-can-i-display-a-modal-dialog-in-redux-that-performs-asynchronous-actions/35641680
//https://medium.com/front-end-hacking/react-redux-no-need-to-component-state-for-modals-73871157b52e
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Modal from 'components/modals/Modal';
import { closeModal } from 'actions/modalActions';

class ModalPortal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

class Modals extends Component {
  render() {
    const modals = this.props.modals.map((item, i) => (
      <ModalPortal key={i}>
        <Modal
          item={item}
          onClose={(modalItem) => this.props.closeModal(modalItem)}
        />
      </ModalPortal>
    ));
    return <div className="modals">{modals}</div>;
  }
}
export default connect(
  function mapStateToProps(state) {
    return {
      modals: state.modals,
    };
  },
  { closeModal }
)(Modals);
